import type { TGetAtendimentoAtivoResponse } from '@/features/atendimento/interfaces'
import { HttpService } from '@/shared/lib'

export class GetAtendimentoAtivoService extends HttpService {
  async execute() {
    const response = await this.http.get<TGetAtendimentoAtivoResponse>('api/v2/Atendimento/ativo')
    return response.data
  }
}
